import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from "@material-ui/core/Grid/Grid";
import Typography from "@material-ui/core/Typography/Typography";
import TextField from "@material-ui/core/TextField/TextField";
import Button from "@material-ui/core/Button/Button";
import {gql, useLazyQuery} from "@apollo/client/index";
import NextCar from "./NextCar";
import Box from "@material-ui/core/Box/Box";
import BuyNow from "./BuyNow";
import * as ReactGA from "react-ga";
import useInitialOffer from "./UseInitialOffer";
import RequestCarInformationForm from "./RequestCarInformationForm";
import ApplyCodeWindow from "./ApplyCodeWindow";
import clsx from 'clsx';
import Offer from "./Offer";
import NotifyRequest from "../Notify/NotifyRequest";
import ContactsForm from "../../Customer/ContactsForm";

const useStyles = makeStyles((theme) => {
    return {
        root: {
            borderRadius: 0,
            boxShadow: 'none',
        },
        priceBlock: {
            width: '100%'
        },
        blockInfo: {
            width: '50%'
        },
        offerInput: {
            maxWidth: 120,
            marginRight: 20,
        },
        offerInputMobile: {
            width: 105,
            marginRight: 10,
        },
        baseRoot: {
            borderRadius: 0
        },
        input: {
            paddingTop: 14,
            paddingBottom: 11,
            fontWeight: 'bold',
            fontSize: '1.2rem',
        },
        discountPrice: {
            color: '#c92b0f !important'
        },
        makeButton: {
            height: 47,
            borderRadius: 0,
            backgroundColor: '#3e4043',
            color: '#e7edef',
            paddingLeft: 10,
            paddingRight: 10,
            ['@media (max-width:360px)']: {
                height: 44,
            },
            ['@media (max-width:320px)']: {
                height: 34,
            },
        },
        makeButtonMobile: {
            height: 47,
            borderRadius: 0,
            backgroundColor: '#3e4043',
            color: '#e7edef',
            padding: '10px 10px',
            marginRight: 4,
        },
        youSave: {
            marginTop: 4,
        },
        youSaveValue: {
            color: '#c92b0f',
        },
        listPriceMobile: {
        },
        listPriceInput: {
            border: 'none',
            width: 100
        },
        inputLp: {
            paddingTop: 14,
            paddingBottom: 11,
            fontWeight: 'normal',
            fontSize: '1.2rem',
            textAlign: 'center'
        },
        mobileLabel: {
            fontWeight: 'normal'
        },

        //------ list price input

        lpInputWrap: {
            marginTop: 30,
            width: 120
        },
        lpInputRoot: {
            color: '#000 !important',
            borderRadius: 0
        },
        lpInput: {
            paddingTop: 16,
            paddingBottom: 13,
            fontWeight: 'normal',
            fontSize: '1rem'
        },

        lpFieldset: {
            borderStyle: 'dashed'
        },

        // --- buy now link

        buyNowButton: {
            marginTop: 30,
            marginLeft: 20,
            height: 47,
            width: 135,
            borderRadius: 0,
            backgroundColor: '#fff',
            color: 'darkblue',
            '&:hover': {
                background: "#fff",
            },
        },

        //--next car
        nextCarRoot: {
            position: 'relative',
            '@media print' : {
                display: 'none'
            }

        },
        tile: {
            maxWidth: 150,
            position: 'absolute',
            right: 0
        },
        tileMini: {
            maxWidth: 100,
            position: 'absolute',
            right: 0
        },
        tileMobile: {
            maxWidth: 130,
            position: 'absolute',
            right: 0
        },
        priceCont: {
            ['@media (min-width:701px)']: {
                marginRight: 20
            },
        },
        listPrice: {
            fontSize: '1.2rem',
            padding: '10px 20px 7px 20px',
            border: '1px dashed #ccc',
            fontWeight: 'bold',
            color: '#111',
            ['@media (max-width:700px)']: {
                padding: '10px 10px 7px 10px',
            },
            ['@media (max-width:360px)']: {
                padding: '10px 5px 7px 5px',
                fontSize: '1.1rem',
            },
            ['@media (max-width:320px)']: {
                width: 73,
                textAlign: 'center',
                marginBottom: 2,
                padding: '5px 5px 1px 5px',
            },
            ['@media (min-width:701px)']: {
                textAlign: 'center',
                width: 118,
                padding: '10px 0px 7px 0px',
            },
        },
        mobileDescriptionTitle: {
            marginTop: 0
        },
        mobileDescriptionTitleMicro: {
            marginTop: 10,
        },
        mobileInquiryTitle: {
            marginTop: 30
        },
        mobileInquiryTitleMicro: {
            marginTop: 10
        },
        codeContainer: {
            position: 'relative',
            width: 'calc(100% - 265px)'
        },
        offerCont: {
            maxWidth: 699
        },
        makeOfferLink: {
            display: 'inline',
            ['@media (max-width:700px)']: {
                marginLeft: '20%',
            },
            ['@media (max-width:360px)']: {
                marginLeft: '10%',
            },
            ['@media (max-width:320px)']: {
                marginLeft: '5%',
            },
        },
        offerSubCont: {
            width: 265
        },
        offerContactsForm: {
            width: '50%',
            marginTop: 20,
        }
    }
});

export default function RequestCarInformationWrapper(props) {
    const classes = useStyles();
    const useOffer = useInitialOffer();

    const item = props.item;
    const [buyNow, setBuyNow] = React.useState(window.location.pathname.indexOf('#buy-now') !== -1);
    const [makeOffer, setMakeOffer] = React.useState();
    const [makeOfferExpanded, setMakeOfferExpanded] = React.useState();
    const [offer, setOffer] = React.useState();

    const isMobile = props.isMobile;
    const isMicro = props.isMicro;
    const isMini = props.isMini;

    const onBuyNow = (e) => {
        e.preventDefault();
        const isOpening = !buyNow;
        if (isOpening) {
            ReactGA.event({
                category: 'User',
                action: 'inquiry_open',
                label: item.sn
            });
        }

        if (makeOfferExpanded) {
            setMakeOfferExpanded(false);
            setOffer(null);
        }

        setBuyNow(isOpening);
    };

    const onMakeOfferClick = (e) => {
        e.preventDefault();
        //setMakeOfferExpanded(!makeOfferExpanded);
        if (buyNow) {
            setBuyNow(false);
        }
        if (makeOfferExpanded) {
            setMakeOfferExpanded(false);
            setOffer(null);
        }
        setMakeOffer(!makeOffer);
    }

    const onSubmitOffer = (e, value) => {
        e.preventDefault();
        setOffer(value);
        setMakeOfferExpanded(true);
        setBuyNow(false);
    }

    const handleContactInformation = (values) => {

    };

    const onOfferChange = (value) => {
        setOffer(value);
        props.onOfferChange(value);
    }

    const form = <form className={classes.root} noValidate autoComplete="off">
        <Button type="submit" variant="contained" size="large" color="primary"
                className={classes.makeButton}
                onClick={onBuyNow}>
            Inquiry
        </Button>
    </form>;

    const actionTitle = makeOffer ? 'Inquiry' : 'Make an offer';

    return (
        <>
            {makeOffer ? <NotifyRequest data={"Make offer click: "+props.item.sn}/> : null}
            {buyNow ? <NotifyRequest data={"Inquiry click: "+props.item.sn}/> : null}
            {props.isMobile ?
                <div className={classes.nextCarRoot}>
                    <Grid container>
                        <Grid item xs={6} sm={6}>
                            {makeOffer ?
                                <Offer item={props.item} youSave={props.youSave} isMobile={props.isMobile} isMicro={props.isMicro} isMini={props.isMini}
                                       onOfferChange={onOfferChange}
                                       onRequestSent={props.onRequestSent}
                                       handleClick={props.handleClick}
                                       onSubmitOffer={onSubmitOffer}/>
                                :
                            <Grid container>
                                {item.dealerPrice ?
                                <Grid item>
                                    <Typography className={clsx(classes.listPrice, item.appliedDiscount ? classes.discountPrice : null)}>
                                        ${new Intl.NumberFormat().format(item.dealerPrice / 100)}
                                    </Typography>
                                </Grid> : null}
                                <Grid item>
                                    {form}
                                    {!item.dealerPrice ? <Box mt={2}/> : null}
                                </Grid>
                            </Grid>}
                        </Grid>
                        <Grid item xs={6} sm={6}>
                            <Grid container>
                                <Grid item xs={12} sm={12} md={4}>
                                    <Typography className={classes.makeOfferLink}>▷ <a href="#" onClick={onMakeOfferClick} aria-label={actionTitle} title={actionTitle}>{actionTitle}</a></Typography>
                                </Grid>
                                <ApplyCodeWindow item={item} isMobile={isMobile} isMini={isMini} isMicro={isMicro}
                                                 refetch={props.refetch} size={props.size}/>
                            </Grid>
                        </Grid>
                    </Grid>


                    {makeOfferExpanded ? null :
                        <Typography variant="h6"
                                className={props.isMicro ? classes.mobileDescriptionTitleMicro
                                    : classes.mobileDescriptionTitle}>Vehicle Description</Typography>}
                </div> :
                <div className={classes.nextCarRoot}>
                    <Grid container className={classes.offerCont}>
                        <Grid item className={classes.offerSubCont}>
                            {makeOffer ?
                                <Offer item={props.item} youSave={props.youSave} isMobile={props.isMobile} isMicro={props.isMicro} isMini={props.isMini}
                                       onOfferChange={onOfferChange}
                                       onRequestSent={props.onRequestSent}
                                       onSubmitOffer={onSubmitOffer}
                                       handleClick={props.handleClick}/>
                                :
                                <Grid container className={classes.priceCont}>
                                    {item.dealerPrice ?
                                       <Grid item>
                                            <Typography className={clsx(classes.listPrice, item.appliedDiscount ? classes.discountPrice : null)}>
                                                ${new Intl.NumberFormat().format(item.dealerPrice / 100)}
                                            </Typography>
                                        </Grid> : null}
                                    <Grid item>
                                        {form}
                                    </Grid>
                                </Grid>}
                        </Grid>
                        <Grid item className={classes.codeContainer}>
                            <Grid container>
                                <Grid item xs={12} sm={12} md={4}>
                                    <Typography className={classes.makeOfferLink}>▷ <a href="#" onClick={onMakeOfferClick} aria-label={actionTitle} title={actionTitle}>{actionTitle}</a></Typography>
                                </Grid>
                                <ApplyCodeWindow item={item} isMobile={isMobile} isMini={isMini} isMicro={isMicro}
                                refetch={props.refetch} size={props.size}/>
                            </Grid>
                        </Grid>
                    </Grid>
                </div>}
            {buyNow ? <RequestCarInformationForm item={item} isMobile={isMobile}/> : null}
            {makeOfferExpanded ? <RequestCarInformationForm item={item} isMobile={isMobile} buttonLabel="Submit Offer" title={"Contact Information"}
            offer={offer}/> : null}
        </>
    );
}
